export default __webpack_public_path__ + "static/img5-a04cddc4d8bc6fdca53332aa3864a3a0.png";